import { useAuth } from 'react-oidc-context';

/** Email de repli lorsque l’utilisateur OIDC n’est pas connecté (POC). */
export const POC_INVENTORY_TRACE_EMAIL_FALLBACK = 'utilisateur.poc@revers.io';

function readEmailFromProfile(profile: Record<string, unknown> | undefined): string {
  if (!profile) {
    return '';
  }

  const email = profile.email;

  if (typeof email === 'string' && email.trim() !== '') {
    return email.trim();
  }

  const preferredUsername = profile.preferred_username;

  if (typeof preferredUsername === 'string' && preferredUsername.includes('@')) {
    return preferredUsername.trim();
  }

  return '';
}

/** Email de l’utilisateur connecté (OIDC), ou repli POC. */
export function useCurrentUserEmail(): string {
  const auth = useAuth();
  const fromAuth = readEmailFromProfile(auth.user?.profile as Record<string, unknown> | undefined);

  return fromAuth || POC_INVENTORY_TRACE_EMAIL_FALLBACK;
}
